import { Box, Typography } from '@mui/material';

type LocationsInfoType = {
  stores: {
    storeId: string;
    title: string;
    smallImage: string;
  }[];
};

const LocationsInfo = ({ stores }: LocationsInfoType) => {
  return (
    <Box>
      {stores?.length === 1 && <Typography>{stores[0]?.title}</Typography>}
      {stores?.length > 1 && (
        <Typography>{`${stores[0]?.title}, +${stores?.length - 1}`}</Typography>
      )}
    </Box>
  );
};

export default LocationsInfo;
